import { Box, Grid, Skeleton, Stack } from "@mui/material"

export const ToolShuffleLoader = () => {
    return (
        <Grid container height="140px" width="100%" direction="row" alignItems="center" spacing="12px">
            {Array(4).fill('').map((v, k) => (
                <Grid key={k} item xs={3} height="100%" width="100%">
                    <Skeleton variant="rectangular" height="100%" width="100%" sx={{borderRadius: '6px'}} />
                </Grid>
            ))}
        </Grid>
    )
}

export const AverageUsageLoader = () => {
    return (
        <Box minHeight="72px" display="flex">
            <Box display="flex" alignItems="center" gap="24px" >
                <Skeleton variant="rectangular" height="72px" width="329px" sx={{borderRadius: '6px'}} />
            </Box>
        </Box>
    )
}

export const UsageAccessLoader = () => {
    return (
        <>
            <AverageUsageLoader/>
            <Box minHeight="21px" >
                <Skeleton variant="text" height="21px" width="100px" sx={{borderRadius: '6px'}} />
            </Box>
            <Box height="100%" className="overflowY">
                
                {Array(5).fill('').map((v,k) => (
                    <Box key={k} height="75px" display="flex" alignItems="center" p="16px 12px 16px 12px" gap={2}>
                        <Skeleton variant="text" height="75px" width="100%" sx={{borderRadius: '6px'}} />
                        <Skeleton variant="rectangular" height="39px" width="49px" sx={{borderRadius: '4px'}} />
                    </Box>
                ))}
            </Box>
        </>
    )
}

export const ActivePercentageLoader = () => {
    return (
        <Stack gap={6}>
            {Array(6).fill('').map((v,k) => (
                <Stack key={k} direction="row" alignItems="center" gap={1}>
                    <Skeleton variant="text" height="26px" width="40px" sx={{borderRadius: '6px'}} />
                    <Skeleton variant="rectangular" height="16px" width="100%" sx={{borderRadius: '16px'}} />
                </Stack>
            ))}
        </Stack>
    )
}

export const AwarePercentageLoader = ({view}) => {

    return (
        view === "" ?
            <Skeleton variant="rectangular" height="450px" width="450px" sx={{borderRadius: '100%'}} /> 
        :
            <Skeleton variant="rectangular" height="350px" width="100%" sx={{borderRadius: '100%'}} />

    )
}

export const UsageAwarenessLoader = () => {
    return (
        Array(10).fill('').map((v,k) => (
            <Stack key={k} gap={1}>
                <Stack minHeight="24px" direction="row" justifyContent="space-between" alignItems="center">
                    <Skeleton variant="text" height="35px" width="150px" sx={{borderRadius: '6px'}} />
                    <Skeleton variant="text" height="35px" width="70px" sx={{borderRadius: '6px'}} />
                </Stack>
                <Skeleton variant="rectangular" height="16px" width="100%" sx={{borderRadius: '16px'}} />
            </Stack>
        ))
    )
}

export const UsedPageLoader = () => {
    return (
        Array(10).fill('').map((mp, i)=>(
            <Grid item xs={3} key={i}>
                <Skeleton variant="rectangular" height="125px" width="100%" sx={{borderRadius: '12px'}} />
            </Grid>
        ))
    )
}